import React from "react";
import styled from "styled-components";
import { LBFooter } from "components";

const PageContainer = styled.div`
	display: flex;
	flex-direction: column;
	font-family: Work Sans;
`;

const BodyContainer = styled.div`
	background: #FFFFFF;
`;

const FooterContainer = styled.div`
	margin: 2em 0;
	background: #F7F7F7;
	padding-left: 6em;
`;

export const GeneralLayout = ({ children, bannerImageUrl, navLink, navLabel, ...otherProps }) => (
  <PageContainer>
    <BodyContainer {...otherProps}>
      {children}
    </BodyContainer>
    <FooterContainer>
      <LBFooter />
    </FooterContainer>
  </PageContainer>
);

export default GeneralLayout;
